import { render, staticRenderFns } from "./mzbd.vue?vue&type=template&id=62ca05d6"
import script from "./mzbd.vue?vue&type=script&lang=js"
export * from "./mzbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports